import { render, staticRenderFns } from "./IbChip.vue?vue&type=template&id=2914ec47"
import script from "./IbChip.vue?vue&type=script&lang=js"
export * from "./IbChip.vue?vue&type=script&lang=js"
import style0 from "./IbChip.vue?vue&type=style&index=0&id=2914ec47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports